import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISetting, ISettingsResponse, SettingType } from "../models/Setting";
import { IReportsResponse } from "../models/report/Report";

export default function useReports() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const reports = useQuery({
    queryKey: ["reports"],
    queryFn: () => get<IReportsResponse>("/report"),
  });

  const runReport = useMutation(
    (body: any) => post(`/report/${body.id}`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["reports"]);
      },
    }
  );


  return {
    reports,
    runReport
  };
}
